import React from 'react'
import Inventory from '../components/Inventory'

const InventoryMgmt = () => {
  return (
    <Inventory/>
  )
}

export default InventoryMgmt;